import * as tslib_1 from "tslib";
import { Component, Vue, Ref } from "vue-property-decorator";
import { UserModule } from "@/store/modules/user";
import { getAudioData, getMediaGroups, initUploadAccessInfo, refreshUploadAccessInfo, saveAudio, uploadAudioCourseware, uploadAudioCover, } from "@/api/material";
import { checkSession } from '@/api/commom';
import WangEditor from "@/components/WangEditor/index.vue";
import eventEmitter from '@/utils/eventEmitter';
let timer = null;
let AudioEdit = class AudioEdit extends Vue {
    constructor() {
        super(...arguments);
        // 音频分组
        this.groups = [
            {
                name: "全部音频",
                value: 0,
            },
        ];
        // 音频详情
        this.audioData = {
            id: "",
            name: "",
            cover: "",
            filename: "",
            fileId: "",
            groupId: 0,
            coursewares: [],
            details: "",
            isCopyAllow: 1,
            isOnlineNow: 1,
            onlineTime: "",
        };
        // 当前音频文件 用于初始化音频上传器
        this.currentAudioFile = [];
        this.isCoverLoading = false; // 音频封面加载状态
        this.isAudioUploading = false; // 音频文件上传状态
        this.isCoursewareUploading = false; // 课件资料上传状态
        this._aliUploader = null; // 阿里云上传器
        // 阿里云上传器访问权限
        this._aliAccess = {
            uploadAuth: "",
            uploadAddress: "",
            videoId: "",
        };
        this.isPrevent = false;
    }
    // private _file_id_cache: string = ""; // 缓存当前音频文件ID
    created() {
        const query = this.$route.query;
        this.initGroupData();
        // 传入ID视为编辑 未传入则为新增
        if (query.id) {
            this.audioData.id = this.$route.query.id;
            this.initAudioData();
        }
        eventEmitter.on('routerRapture', () => {
            return this.isPrevent ? Promise.resolve() : Promise.reject();
        });
        // 配置阿里云上传器
        const AliyunUpload = window.AliyunUpload;
        this._aliUploader = new AliyunUpload.Vod({
            userId: "1197011945138604",
            region: "cn-shanghai",
            partSize: 1048576,
            parallel: 5,
            retryCount: 3,
            retryDuration: 2,
            enableUploadProgress: true,
            onUploadstarted: this.handleAudioUploadStart,
            onUploadSucceed: this.handleAudioUploadSucceed,
            onUploadFailed: () => {
                this.$message.error("上传失败");
                this.isAudioUploading = false;
            },
            onUploadTokenExpired: () => {
                this.$message.error("上传凭证已失效");
                this.isAudioUploading = false;
            },
        });
        const t = 1 * 60 * 1000;
        timer = setInterval(() => {
            this.checkHeartbeat();
        }, t);
    }
    beforeDestroy() {
        clearInterval(timer);
    }
    async checkHeartbeat() {
        await checkSession();
    }
    // 获取分组列表
    async initGroupData() {
        const res = await getMediaGroups();
        if (res.data.status !== 200)
            return;
        const data = res.data.data;
        if (!data)
            return;
        this.groups = [
            // 默认置顶【全部音频】分组
            {
                name: "全部音频",
                value: 0,
            },
            ...data.map((group) => {
                return {
                    name: group.name,
                    value: Number(group.id),
                };
            }),
        ];
    }
    // 获取音频数据
    async initAudioData() {
        const res = await getAudioData(this.audioData.id);
        if (res.data.status !== 200)
            return;
        const data = res.data.data;
        if (!data)
            return;
        this.audioData = {
            id: data.id,
            name: data.title,
            cover: data.coverUrl,
            filename: data.videoName,
            fileId: data.videoId,
            groupId: Number(data.groupId),
            isCopyAllow: data.isCopy,
            isOnlineNow: data.onlineNow,
            details: data.content,
            onlineTime: data.delayedTime,
            coursewares: data.coursewares.map((courseware) => {
                return {
                    // id: String(courseware.id),
                    name: courseware.name,
                    url: courseware.url,
                    actionType: courseware.actionType,
                };
            }),
        };
        // 配置当前音频文件
        if (data.videoName) {
            this.currentAudioFile = [{ name: data.videoName, url: "" }];
        }
        if (data.content) {
            this.wangEditor.setContent(data.content);
        }
        // this._file_id_cache = data.videoId;
    }
    // 选择音频封面
    handleCoverSelect(file) {
        const isLt5M = file.size / 1024 / 1024 < 5;
        if (!isLt5M) {
            this.$message.error("封面图片大小不能超过 5MB!");
            return false;
        }
        const isJPG = file.type === "image/jpg" || file.type === "image/jpeg";
        const isPNG = file.type === "image/png";
        if (!(isJPG || isPNG)) {
            this.$message.error("封面图片只能是JPG/PNG格式!");
            return false;
        }
        return true;
    }
    // 上传音频封面
    async handleCoverUpload(data) {
        this.isCoverLoading = true;
        const file = data.file;
        try {
            const res = await uploadAudioCover(file, {
                token: UserModule.token,
                ssoId: UserModule.ssoId,
            });
            // 防止奇奇怪怪的人卡bug, 重置状态后再取消禁用上传
            this.$nextTick(() => {
                this.isCoverLoading = false;
            });
            if (res.data.status !== 200) {
                return this._coverUploader.clearFiles();
            }
            this.audioData.cover = res.data.data;
        }
        catch {
            this.isCoverLoading = false;
        }
    }
    // 选择音频文件
    handleAudioSelect(file) {
        const isLt500M = file.size / 1024 / 1024 < 500;
        if (!isLt500M) {
            this.$message.error("音频文件大小不能超过 500MB!");
            return false;
        }
        const isMP3 = file.type === "audio/mpeg";
        // const isM4A: boolean = file.type === "audio/x-m4a";
        if (!isMP3) {
            this.$message.error("音频文件仅支持MP3格式!");
            return false;
        }
        return true;
    }
    // 上传音频文件
    async handleAudioUpload(data) {
        this.isAudioUploading = true;
        const file = data.file;
        // let isAuth: boolean = false;
        // if (this._file_id_cache) {
        //   isAuth = await this.handleUploadAccesRefresh(this._file_id_cache);
        // } else {
        //   isAuth = await this.handleUploadAccessInit(file.name);
        // }
        // 获取访问授权
        const isAuth = await this.handleUploadAccessInit(file.name);
        if (isAuth) {
            this._aliUploader.addFile(file, null, null, null, '{"Vod":{}}');
            this._aliUploader.startUpload();
        }
    }
    // 移除音频文件
    handleAudioRemove() {
        this.audioData.fileId = "";
        this.audioData.filename = "";
    }
    // 处理音频文件已存在时用户请求上传
    handleAudioExceed() {
        this.$message.warning("请先移除当前音频后再次尝试上传");
    }
    // 阿里云上传器预处理（上传音频文件）
    async handleAudioUploadStart(uploadInfo) {
        if (uploadInfo.videoId) {
            const isAuth = await this.handleUploadAccesRefresh(uploadInfo.videoId);
            if (!isAuth)
                return;
        }
        const access = this._aliAccess;
        this._aliUploader.setUploadAuthAndAddress(uploadInfo, access.uploadAuth, access.uploadAddress, access.videoId);
    }
    // 阿里云上传器上传成功（上传音频文件）
    handleAudioUploadSucceed(uploadInfo) {
        this.audioData.fileId = uploadInfo.videoId;
        this.audioData.filename = uploadInfo.file.name;
        this.$message.success("上传成功");
        this.isAudioUploading = false;
    }
    // 获取阿里云授权（创建音频）
    async handleUploadAccessInit(name) {
        const res = await initUploadAccessInfo(name);
        if (res.data.status !== 200)
            return false;
        const data = res.data.data;
        if (!data)
            return false;
        this._aliAccess = {
            uploadAuth: data.uploadAuth,
            uploadAddress: data.uploadAddress,
            videoId: data.videoId,
        };
        return true;
    }
    // 获取阿里云授权（更新音频）
    async handleUploadAccesRefresh(id) {
        const res = await refreshUploadAccessInfo(id);
        if (res.data.status !== 200)
            return false;
        const data = res.data.data;
        if (!data)
            return false;
        this._aliAccess = {
            uploadAuth: data.uploadAuth,
            uploadAddress: data.uploadAddress,
            videoId: data.videoId,
        };
        return true;
    }
    // 选择音频关联课件
    handleCoursewareSelect(file) {
        const isLt20M = file.size / 1024 / 1024 < 20;
        if (!isLt20M) {
            this.$message.error("课件大小不能超过 20MB!");
            return false;
        }
        // const isPPT: boolean =
        //   file.type === "application/vnd.ms-powerpoint" ||
        //   file.type ===
        //     "application/vnd.openxmlformats-officedocument.presentationml.presentation";
        const isPDF = file.type === "application/pdf";
        if (!isPDF) {
            this.$message.error("课件资料只能是PDF格式!");
            return false;
        }
        return true;
    }
    // 上传音频关联课件
    async handleCoursewareUpload(data) {
        this.isCoursewareUploading = true;
        const file = data.file;
        const res = await uploadAudioCourseware(file, {
            token: UserModule.token,
            ssoId: UserModule.ssoId,
        });
        this.isCoursewareUploading = false;
        if (res.data.status !== 200)
            return;
        this.audioData.coursewares.push({
            name: file.name,
            url: res.data.data,
            actionType: 2,
        });
    }
    // 移除音频关联课件
    handleCoursewareRemove(file) {
        const idx = this.audioData.coursewares.findIndex((courseware) => courseware.name === file.name);
        if (idx === -1)
            return;
        this.audioData.coursewares.splice(idx, 1);
    }
    // 预览音频关联课件
    previewCourseware(file) {
        window.open(file.url, "_blank");
    }
    // 保存音频数据
    async saveAudioData() {
        const audio = this.audioData;
        if (audio.cover === "") {
            return this.$message.error("请上传封面图");
        }
        if (audio.name === "") {
            return this.$message.error("音频标题不能为空");
        }
        if (audio.fileId === "") {
            return this.$message.error("音频文件不能为空");
        }
        console.log(audio);
        if (audio.isOnlineNow === 0) {
            if (!audio.onlineTime)
                return this.$message.error("定时上架时间不能为空");
            if (new Date(audio.onlineTime) < new Date())
                return this.$message.error("定时上架时间不能为小于当前时间");
        }
        const data = {
            id: audio.id,
            title: audio.name,
            coverUrl: audio.cover,
            content: audio.details,
            videoName: audio.filename,
            videoId: audio.fileId,
            coursewares: audio.coursewares.map(
            // 过滤掉el-upload生成的字段
            (courseware) => {
                return {
                    name: courseware.name,
                    url: courseware.url,
                    actionType: courseware.actionType,
                };
            }),
            groupId: `${audio.groupId}`,
            isCopy: audio.isCopyAllow,
            onlineNow: audio.isOnlineNow,
            delayedTime: audio.onlineTime,
        };
        const res = await saveAudio(data);
        if (res.data.status !== 200)
            return;
        this.$message.success("保存成功");
        this.isPrevent = true;
        setTimeout(() => {
            this.$router.push({ path: "/data-manager/audio" });
        }, 300);
    }
};
tslib_1.__decorate([
    Ref()
], AudioEdit.prototype, "_coverUploader", void 0);
tslib_1.__decorate([
    Ref()
], AudioEdit.prototype, "wangEditor", void 0);
AudioEdit = tslib_1.__decorate([
    Component({
        name: "AudioEdit",
        components: {
            "wangEditor": WangEditor,
        },
    })
], AudioEdit);
export default AudioEdit;
